import { render, staticRenderFns } from "./SessionExpiredDialog.vue?vue&type=template&id=51efae8b&scoped=true"
import script from "./SessionExpiredDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SessionExpiredDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51efae8b",
  null
  
)

export default component.exports